const config = {
  API_URL: 'https://apps-api.keboola.com', // API url (without trailing slash)
  BASE_PATH: '',
};

export default config;
